export class AttachmentFile {
    fileName: string;
    contentType: string;
    content: any;
}

export class AttachmentInfo{
    public id: number;
    public name: string;
    public size: string;
    public extension: string;
    public createdDate: Date;
    public fileString: string;
    public contentType: string;
}

export class AttachmentUploadParameter {
    public file: string;
    public fileName: string;
    public objectTypeId : number;
    public objectId : number;
    public controller : string;
}

export class AttachmentDeleteParameter {
    public attachmentId : number;
    public controller : string;
}

export interface AttachmentHolder {
    attachments: AttachmentInfo[];
    objectTypeId : number;
    id : number;
}